import { useState, useEffect, useCallback } from 'react';
import { api } from './api';

/**
 * Shared hook to load and manage product categories from the backend.
 * Replaces the previously hardcoded PRODUCT_TYPES array.
 */
export default function useProductCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get('/product-categories');
      setCategories(data);
    } catch (e) {
      // silent — caller can show a toast if needed
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  /** Create a new category. Returns the saved record on success. */
  const create = async ({ label, color = '#0E2D43', bg = '#F1F5F9', sort_order = 99 }) => {
    const { data } = await api.post('/product-categories', { label, color, bg, sort_order });
    setCategories(prev => [...prev, data].sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0)));
    return data;
  };

  return { categories, loading, reload, create };
}
